import { render } from "./entrustment.vue?vue&type=template&id=6b491802&scoped=true"
import script from "./entrustment.vue?vue&type=script&lang=js"
export * from "./entrustment.vue?vue&type=script&lang=js"

import "./entrustment.vue?vue&type=style&index=0&id=6b491802&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b491802"]])

export default __exports__